import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DefiningPremiumLiving() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="14914" id="the-projectora-anthem" className="dark bg-[#0d1b2a] bg-gradient-to-b from-[#060f1a] via-[#0d1b2a] to-[#060f1a] text-foreground relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-black/50 z-10 bg-gradient-to-b from-background/90 via-transparent to-background/90 !bg-[url(https://climbing-leech-1.10web.cloud/wp-content/uploads/2026/03/Gemini_Generated_Image_h5l260h5l260h5l2.png)]" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/premium_consultancy_hero_bg.png" alt="Projectora Consulting Auckland" className="w-full h-full object-cover scale-105 animate-subtle-zoom" />
      </div>

      {}
      <div ref={ref} className="relative z-20 container mx-auto px-4 py-8 text-center transition-all duration-1000 ease-out opacity-100 translate-y-0 !text-[hsl(0,0%,100%)]">
        <span className="inline-block text-primary font-mono tracking-[0.3em] uppercase text-xs md:text-sm mb-6 opacity-80 font-bold">
          Auckland's Premier Project Management Consultancy
        </span>
        
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter mb-8 max-w-5xl mx-auto leading-[0.85] text-white">YOUR&nbsp; PROJECT.<br /><span className="text-[#00c4b4]" data-ast-id="f:/src/pages/Home/sections/DefiningPremiumLiving.tsx|sig:p8yc2l" data-ast-start="1680" data-ast-end="1727">DELIVERED&nbsp; ON SCOPE.</span></h1>

        <p className="text-lg mb-12 max-w-2xl mx-auto font-bold leading-relaxed text-white md:text-xl">&nbsp; &nbsp; &nbsp;Network &amp; Device Refresh Specialist -&nbsp; Projectora is New Zealand's <span className="text-white">most experienced cutover delivery partner</span>.&nbsp;</p>

        <div className="flex flex-col sm:flex-row justify-center items-center gap-3">
          <Button asChild size="lg" className="h-14 px-10 text-lg bg-[#00c4b4] hover:bg-[#00c4b4]/90 text-white rounded-sm transition-transform hover:scale-105 relative group overflow-hidden border-none">
            <Link to="/ServicesPage">
              Explore Our Expertise
              <div className="absolute inset-0 bg-white/10 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-500" />
            </Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 px-10 text-lg border-[#00c4b4] text-[#00c4b4] hover:bg-[#00c4b4]/10 rounded-sm transition-all bg-transparent">
            <Link to="/ContactPage">Get in Touch</Link>
          </Button>
        </div>
      </div>

      {}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3 text-primary/60">
        <span className="text-[10px] uppercase tracking-[0.4em] font-black">Scroll</span>
        <div className="p-2 rounded-lg border border-primary/20 animate-bounce">
          <ArrowDown className="w-5 h-5 text-[#00c4b4]" />
        </div>
      </div>

      <style jsx global>{`
        @keyframes subtle-zoom {
          0% { transform: scale(1.05); }
          100% { transform: scale(1.15); }
        }
        .animate-subtle-zoom {
          animation: subtle-zoom 20s infinite alternate ease-in-out;
        }
        @keyframes pulse-ring {
          0% {
            box-shadow: 0 0 0 0 rgba(0, 148, 135, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(0, 148, 135, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(0, 148, 135, 0);
          }
        }
      `}</style>
    </section>;
}